import {
  Box,
  Button,
  Heading,
  HStack,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react'
import { useTheme } from '@emotion/react'
import {
  // faLock,
  faUserMinus,
  faUserXmark,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback, useState } from 'react'
import { employeeStatus } from '../../variables/employees'
import ActionButton from './components/ActionButton'
import ConfirmModal from './components/ConfirmModal'
import Indicators from './components/Indicators'
import InfoGrid from './components/InfoGrid'
import { EmployeeDataContext, useEmployeeData } from './useEmployeeData'

export default function EmployeeDetails() {
  const {
    employee,
    loading,
    canActivate,
    handleChangeData,
    handleChangeState,
    handleUnlinkEmployee,
    onClose,
    // sendPin,
    handleUpdateEmployee,
  } = useEmployeeData()
  const {
    isOpen: isOpenConfirm,
    onOpen: handleOpenConfirm,
    onClose: handleCloseConfirm,
  } = useDisclosure()
  const [isUnlink, setIsUnlink] = useState(null)
  const handleOpenUnlink = () => {
    setIsUnlink(true)
    handleOpenConfirm()
  }
  const handleOpenChangeStatus = () => {
    setIsUnlink(false)
    handleOpenConfirm()
  }
  const handleCloseConfirmModal = () => {
    setIsUnlink(null)
    handleCloseConfirm()
  }

  const confirmFunction = useCallback(() => {
    if (isUnlink) {
      handleUnlinkEmployee()
    } else if (isUnlink === false) {
      handleChangeState()
    }
    handleCloseConfirm()
  }, [isUnlink, handleChangeState, handleUnlinkEmployee])

  const { colors } = useTheme()
  return (
    <>
      {employee && (
        <ConfirmModal
          isOpen={isOpenConfirm}
          onClose={handleCloseConfirmModal}
          data={employee}
          handleConfirm={confirmFunction}
        />
      )}
      <VStack
        spacing="70px"
        justifyContent="center"
        alignItems="flex-start"
        mb="40px"
      >
        <Button onClick={onClose} variant="fullWidth">
          <HStack>
            <FontAwesomeIcon icon={faXmark} />
            <Text>Cerrar información de colaborador</Text>
          </HStack>
        </Button>
        <HStack
          w="100%"
          alignItems="flex-start"
          // justifyContent="space-between"
          spacing={0}
          gap="20px"
          wrap="wrap"
        >
          <EmployeeDataContext.Provider
            value={{ employee, handleChangeData, handleUpdateEmployee }}
          >
            <Box w={['100%', '100%', '100%', '65%', '60%']}>
              <InfoGrid />
            </Box>
          </EmployeeDataContext.Provider>
          <Box w={['100%', '100%', '50%', '30%', '30%']}>
            <Indicators loading={loading} data={employee} />
          </Box>
        </HStack>

        <VStack alignItems="flex-start" w="100%">
          <Heading variant="h5">
            {' '}
            {employee?.sEstado !== employeeStatus.unlinked
              ? 'Acciones disponibles'
              : 'No hay acciones disponibles'}
          </Heading>
          {employee?.sEstado !== employeeStatus.unlinked && (
            <HStack
              justifyContent="flex-start"
              w="100%"
              spacing={0}
              // spacing={'30px'}
              wrap="wrap"
              gap={'20px'}
            >
              {/* <ActionButton
              text="ENVÍAR PIN DE ACTIVACIÓN BOLSILLO"
              icon={faLock}
              onCLick={sendPin}
            /> */}

              <ActionButton
                text="DESVINCULAR COLABORADOR"
                icon={faUserXmark}
                onCLick={handleOpenUnlink}
              />
              <ActionButton
                bgColor={colors.primary.lighter}
                textColor="white"
                text={
                  canActivate ? 'ACTIVAR COLABORADOR' : 'SUSPENDER COLABORADOR'
                }
                icon={faUserMinus}
                onCLick={handleOpenChangeStatus}
              />
            </HStack>
          )}
        </VStack>
      </VStack>
    </>
  )
}
